import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: "user" })
export class UserPipe implements PipeTransform {
  transform(users: any[], value: string): any {
    if (!users) return [];
    if (!value || value.length == 0) return users;
    return users.filter(
      (user) =>
        (user.firstName &&
          user.firstName.toLowerCase().indexOf(value.toLowerCase()) >= 0) ||
        (user.lastName &&
          user.lastName.toLowerCase().indexOf(value.toLowerCase()) >= 0) ||
        (user.personalId &&
          user.personalId.toLowerCase().indexOf(value.toLowerCase()) >= 0)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/_helpers/user-pipe.ts